import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../../shared';
import { VigenciaCampanhaFormControlModule } from '../../../vigencia/form-control-radio';
import { SobDemandaFormControlModule } from '../../../components/sob-demanda-form-control-radio';
import { CampanhaVigenciaFormComponent } from './campanha-vigencia-form.component';

@NgModule({
    imports: [
        SharedModule,
        VigenciaCampanhaFormControlModule,
        SobDemandaFormControlModule
    ],
    declarations: [
        CampanhaVigenciaFormComponent
    ],
    exports: [
        CampanhaVigenciaFormComponent
    ]
})
export class CampanhaVigenciaFormModule { }
